import styled from "styled-components";

import { IThemeProps } from "@/styles/Theme";

export const Icon = styled.span<IThemeProps>`
  &:not(:first-child) {
    margin-left: ${(props: IThemeProps) => props.theme.spacing.desktop.s500}px;
  }
  cursor: pointer;
`;
